import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { ff } from '@atlassian/jira-feature-flagging-using-meta';
import {
	getBoardScopeGraphqlQuery,
	softwareBoardScopeCriticalDataOperationName,
} from '@atlassian/jira-software-board-fetch-scope-critical-query';
import { query$ } from '@atlassian/jira-software-swag';
import { boardScopeDataCriticalAnalyticsOptions } from './constants';
import type { BoardScopeGQL } from './types';

export type {
	BoardScopeGQL,
	BoardGQLCritical,
	Capabilities,
	BoardFeatureToggleStatus,
	Etag,
	BoardFeatureKey,
	BoardFeatureStatus,
	BoardFeatures,
	StatusGQL,
	TransitionGQL,
	ErrorGQL,
	ColumnStatusGQL,
	JiraUserGQL,
	SprintGQL,
	InlineCardCreateConfigGQL,
	InlineCardCreateIssueTypeConfigGQL,
	InlineCardCreateModeGQL,
	IssueTypeGQL,
	IssueGQL,
	IssueParentResponseGQL,
	ColumnCardIssueGQL,
	EstimateGQL,
	EstimationStatistic,
	CardGQL,
	ColumnDetailsGQL,
	ColumnInSwimlaneGQL,
	SwimlaneGQL,
	BoardScopeBoardGQLCritical,
	BoardGQLExtension,
	CardChildGQL,
	ColumnCardGQL,
	ColumnWithCardsGQL,
	BoardGQL,
	SwimlaneStrategyGQL,
	BoardFeatureGQL,
	BoardPermissionsGQL,
	BoardScopeBoardGQLNonCritical,
	JiraGQL,
	BoardScopeCriticalGQL,
} from './types';

type Response = {
	boardScope: BoardScopeGQL;
};

export const parseResponse = (result: Response): ObservableType<BoardScopeGQL> =>
	Observable.of(result.boardScope);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (contextPath: string, boardId: string): ObservableType<BoardScopeGQL> =>
	query$<Response>(
		contextPath,
		softwareBoardScopeCriticalDataOperationName,
		getBoardScopeGraphqlQuery(),
		{ boardId, useBackendIccConfig: ff('use-backend-tmp-icc-config-_4bgin') },
		boardScopeDataCriticalAnalyticsOptions,
	).flatMap(parseResponse);
